import { isRouteErrorResponse, useRouteError } from 'react-router';

import { messages } from '../messages';
import { HOME_PATH } from '../paths';

/**
 * The router's error boundary.
 *
 * A thrown route error is a client-side failure — most often a screen's code that could not be
 * downloaded after a deploy — so it is reported in the interface's own Georgian and never by printing
 * the error. It deliberately depends on nothing that may itself have failed: no design page, no
 * stylesheet, only inline styles and a plain link that reloads the application from its entry address.
 * A 404 response reaching here is the same situation as an unknown address, and is worded as such.
 */
export function RouteErrorRoute() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <main role="alert" style={{ maxWidth: '32rem', margin: '0 auto', padding: '3rem 1.5rem', fontFamily: 'system-ui, sans-serif', lineHeight: 1.5 }}>
      <h1 style={{ fontSize: '1.375rem', margin: '0 0 0.5rem' }}>
        {notFound ? messages.shell.notFoundHeading : messages.shell.unexpectedHeading}
      </h1>
      <p style={{ margin: '0 0 1rem' }}>{notFound ? messages.shell.notFoundBody : messages.shell.unexpectedBody}</p>
      <a href={HOME_PATH}>{messages.shell.backToHome}</a>
    </main>
  );
}
